import { UNAPPROVED_TRANSLATORS, REMOVE_UNAPPROVED_TRANSLATORS } from '../constants/actionTypes'

const translatorActions = (translators = { unapproved: [] }, action) => {
    switch (action.type) {
        case UNAPPROVED_TRANSLATORS:
            return {...translators, unapproved:[...translators.unapproved, ...action?.payload]}
        case REMOVE_UNAPPROVED_TRANSLATORS:
            const unapprovedIndex = translators.unapproved.findIndex((translator) => 
                translator._id === action.id
            )
            let unapprovedTranslators = [...translators.unapproved]

            if(unapprovedIndex !== -1) {
                unapprovedTranslators.splice(unapprovedIndex, 1)
            }
            
            return {...translators, unapproved: unapprovedTranslators}
        default:
            return translators;
    }
}

export default translatorActions